import React, { useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import CloseIcon from "@mui/icons-material/Close";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import AppContext from "../../appContext";
import { filterOptions } from "./filterOptions";

function Title({ filterOption, handleFilterItemClick }) {
  const {
    app: {
      client: { id },
    },
  } = useContext(AppContext);
  const { dispatch } = useContext(AppContext);
  const { t } = useTranslation();

  const [openFilter, setOpenFilter] = useState(false);
  const openMenuFilter = Boolean(openFilter);
  const handleFilterMenu = (event) => {
    setOpenFilter(event.currentTarget);
  };
  const handleFilterClose = () => {
    setOpenFilter(false);
  };
  const handleItemClick = (option) => {
    handleFilterItemClick(option);
    handleFilterClose();
  };

  const titles = {
    filterActiveClients: t("navigation.clients.active"),
    filterArchivedClients: t("navigation.clients.archived"),
    filterExampleClients: t("navigation.clients.example"),
    filterTemplateClients: "Templates",
  };

  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      justifyContent={"flex-end"}
      paddingRight={1}
    >
      <ListItem>
        <Button
          onClick={handleFilterMenu}
          endIcon={<ArrowDropDownIcon />}
          sx={{ color: "text.primary" }}
        >
          <Typography variant="h6">{titles[filterOption.id]}</Typography>
        </Button>
      </ListItem>
      <IconButton
        size="small"
        onClick={() => dispatch({ type: "SET_OPEN", payload: false })}
      >
        <CloseIcon fontSize="small"></CloseIcon>
      </IconButton>
      <Menu
        id="menu-clients-filter"
        anchorEl={openFilter}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        disableScrollLock={true}
        open={openMenuFilter}
        onClose={handleFilterClose}
      >
        {filterOptions.map((option) => (
          <MenuItem
            key={option.id}
            onClick={() => handleItemClick(option)}
            selected={filterOption.id === option.id}
          >
            <List dense={true} sx={{ margin: 0, padding: 0 }}>
              <ListItem sx={{ margin: 0, padding: 0 }}>
                <ListItemText primary={titles[option.id]} />
              </ListItem>
            </List>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}

export default Title;
